<app-tabla
  [totalCount]="totalCount"
  [datos]="reportes"
  [columnas]="columnas"
  [name]="name"
  [pageSizeOptions]="helper.pageSizeOptions"
  [search]="search"
  [(query)]="query"
  (queryChange)="listar()"
  [paginatorArriba]="false"
  [showHijos]="false"
  [emptyState]="{ title: 'Todavía no hay reportes' }"
></app-tabla>
